var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.row.task_status == 0)?_c('div',[_vm._v("导入中…")]):_c('div',[_c('span',[_vm._v("成功"),_c('span',{staticClass:"ml-4 success"},[_vm._v(_vm._s(_vm.row.success_count))])]),(_vm.row.task_status != 1)?_c('span',{staticClass:"ml-24"},[_vm._v("失败"),_c('span',{staticClass:"ml-4 error"},[_vm._v(_vm._s(_vm.row.fail_count))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }